<template>
  <div>
    <div class="row" v-if="ready">
      <div class="col-3">
        <div class="logoContainer card">
          <div class="card-header">
            <h4>Profilbild</h4>
          </div>
          <div class="image-preview" v-if="!showDZ">
            <img :src="avatarURL"/>
          </div>
          <div class="upload-dropzone card-body" style="margin-bottom:10px;margin-top:10px;">
            <dropzone
              ref="profile_kundenbild_dropzone"
              id="profile_kundenbild_dropzone"
              class=""
              :options="dropzone_options"
              v-on:vdropzone-file-added="refreshDropzoneAuth"
              v-on:vdropzone-success="processImageUpload"
              v-if="showDZ"
            ></dropzone>
          </div>
          <feather type="refresh-cw" class="infra-blue pointer" @click="showDZ = !showDZ" style="padding:10px;"/>
        </div>
        <div class="password-reset-container card">
          <div class="card-header">
            <h4>Neues Passwort</h4>
          </div>
          <div class="card-body">
            <label>
              Passwort
            </label>
            <transition :name="animations.standard.name" :enter-active-class="animations.standard.enter" :leave-active-class="animations.standard.leave" mode="out-in">
            <div class="form-error inline-block red" v-if="newPassword.error.notSame">&nbsp;- Passwörter stimmen nicht überein.</div>
            <div class="form-error inline-block red" v-if="newPassword.error.empty">&nbsp;- Passwort darf nicht leer sein.</div>
            </transition>
            <b-input-group prepend="Abc" class="form-input-group">
              <b-form-input type="password" v-model="newPassword.once" :disabled="updating.password"></b-form-input>
            </b-input-group>
            <label>Wiederholung</label>
            <b-input-group prepend="Abc" class="form-input-group">
              <b-form-input type="password" v-model="newPassword.twice" :disabled="updating.password"></b-form-input>
            </b-input-group>
            <b-button @click="validateNewPassword">Passwort setzen</b-button>
          </div>
        </div>
      </div>
      <div class="col-9">
        <div class="dataContainer card">
          <div class="card-header">
            <h4>Ihre Daten</h4>
          </div>
          <div class="form-fields card-body">
            <div class="row">
              <div class="col-6">
                <div class="row">
                  <div class="col-6">
                    <label>Vorname</label>
                    <div class="red inline-block" v-if="hasError('first_name')">
                      - mindestens {{ validation.kunden.first_name.minlength }} Zeichen.
                    </div>
                    <b-input-group prepend="Abc" class="form-input-group">
                      <b-form-input
                        v-model="kunde.first_name"
                        v-bind:class="{ form_error: hasError('first_name') }"
                        name="first_name"
                        :disabled="updating.first_name"
                        @blur="validate"
                      ></b-form-input>
                      <div class="inline-loader-indicator">
                        <feather type="check" v-if="!updating.first_name" class="checkmark"></feather>
                        <Loader size="20" v-if="updating.first_name" />
                      </div>
                    </b-input-group>
                  </div>
                  <div class="col-6">
                    <label>Nachname</label>
                    <div class="red inline-block" v-if="hasError('last_name')">- mindestens {{ validation.kunden.last_name.minlength }} Zeichen.</div>
                    <b-input-group prepend="Abc" class="form-input-group">
                      <b-form-input
                        v-model="kunde.last_name"
                        v-bind:class="{ form_error: hasError('last_name') }"
                        name="last_name"
                        :disabled="updating.last_name"
                        @blur="validate"
                      ></b-form-input>
                      <div class="inline-loader-indicator">
                        <feather type="check" v-if="!updating.last_name" class="checkmark"></feather>
                        <Loader size="20" v-if="updating.last_name" />
                      </div>
                    </b-input-group>
                  </div>
                </div>
                <label>E-Mail</label>
                <div class="red inline-block" v-if="hasError('email')">- Bitte geben Sie eine gültige E-Mail Adresse ein.</div>
                <b-input-group prepend="Abc" class="form-input-group">
                  <b-form-input
                    v-model="kunde.email"
                    v-bind:class="{ form_error: hasError('email') }"
                    name="email"
                    :disabled="updating.email"
                    @blur="validate"
                  ></b-form-input>
                  <div class="inline-loader-indicator">
                    <feather type="check" v-if="!updating.email" class="checkmark"></feather>
                    <Loader size="20" v-if="updating.email" />
                  </div>
                </b-input-group>
                <label>Telefon</label>
                <div class="red inline-block" v-if="hasError('telefon')">- Bitte geben Sie eine gültige Telefonnummer ein.</div>
                <b-input-group prepend="Abc" class="form-input-group">
                  <b-form-input
                    v-model="kunde.telefon"
                    v-bind:class="{ form_error: hasError('telefon') }"
                    name="telefon"
                    :disabled="updating.telefon"
                    @blur="validate"
                  ></b-form-input>
                  <div class="inline-loader-indicator">
                    <feather type="check" v-if="!updating.telefon" class="checkmark"></feather>
                    <Loader size="20" v-if="updating.telefon" />
                  </div>
                </b-input-group>
                <label>Zusätzliche E-Mail-Adressen</label>
                <b-input-group prepend="@" class="form-input-group">
                  <b-form-input
                  v-model="new_additional_email"
                  name="additional_email"                  
                  ></b-form-input>
                  <div class="input-buttons-right">
                    <feather type="plus" class="icon-button pointer" @click="addEmail()"></feather>
                  </div>                  
                </b-input-group>
                <div class="additional-emails-container">
                  <div class="additional-email-item" v-for="(email, idx) in additional_email" :key="`add-email-${idx}`">
                  <div class="additiona-email-txt">{{email}}</div>
                  <feather type="minus" class="icon-button pointer" @click="removeEmail(idx)" v-if="email"></feather>
                  </div>                  
                </div>
              </div>
              <div class="col-6">
                <label>Straße</label>
                <div class="red inline-block" v-if="hasError('strasse')">- Keine Sonderzeichen erlaubt</div>
                <b-input-group prepend="Abc" class="form-input-group">
                  <b-form-input v-model="kunde.strasse" name="strasse" :disabled="updating.strasse" @blur="validate"></b-form-input>
                  <div class="inline-loader-indicator">
                    <feather type="check" v-if="!updating.strasse" class="checkmark"></feather>
                    <Loader size="20" v-if="updating.strasse" />
                  </div>
                </b-input-group>
                <div class="row">
                  <div class="col-6">
                    <label>Ort</label>
                    <div class="red inline-block" v-if="hasError('ort')">- Keine Sonderzeichen erlaubt</div>
                    <b-input-group prepend="Abc" class="form-input-group">
                      <b-form-input v-model="kunde.ort" name="ort" :disabled="updating.ort" @blur="validate"></b-form-input>
                      <div class="inline-loader-indicator">
                        <feather type="check" v-if="!updating.ort" class="checkmark"></feather>
                        <Loader size="20" v-if="updating.ort" />
                      </div>
                    </b-input-group>
                  </div>
                  <div class="col-6">
                    <label>PLZ</label>
                    <div class="red inline-block" v-if="hasError('plz')">- Bitte nur Zahlen eingeben</div>
                    <b-input-group prepend="Abc" class="form-input-group">
                      <b-form-input v-model="kunde.plz" name="plz" :disabled="updating.plz" @blur="validate"></b-form-input>
                      <div class="inline-loader-indicator">
                        <feather type="check" v-if="!updating.plz" class="checkmark"></feather>
                        <Loader size="20" v-if="updating.plz" />
                      </div>
                    </b-input-group>
                  </div>
                </div>
                <label>Anmerkungen</label>
                <div class="red inline-block" v-if="hasError('beschreibung')">- Keine Sonderzeichen erlaubt.</div>
                <b-input-group prepend="Abc" class="form-input-group">
                  <b-textarea
                    v-model="kunde.beschreibung"
                    rows="3"
                    name="beschreibung"
                    :disabled="updating.beschreibung"
                    @blur="validate"
                  ></b-textarea>
                  <div class="textarea-loader-indicator">
                    <feather type="check" v-if="!updating.beschreibung" class="checkmark"></feather>
                    <Loader size="20" v-if="updating.beschreibung" />
                  </div>
                </b-input-group>
              </div>
            </div>
            <b-button style="float:right;" @click="saveUser()">Speichern</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vue2Dropzone from "vue2-dropzone";
import Loader from "@/components/loader.vue";

export default {
  name: "KundeProfile",
  components: {
    dropzone: vue2Dropzone,
    Loader,
  },
  data() {
    return {
      validation_errors: [],
      dropzone_options: null,
      ready: false,
      new_additional_email: "",
      additional_email : [],
      avatarURL: false,
      showDZ: true,
      updating: {
        first_name: false,
        last_name: false,
        email: false,
        telefon: false,
        strasse: false,
        ort: false,
        plz: false,
        beschreibung: false,
        password: false,
      },
      changedData: {},
      newPassword: {
        once: "",
        twice: "",
        error: {
          notSame: false,
          empty: false,
          tooSimple: false,
        },
      },
      oldVals: {},
      required: ["first_name", "last_name", "email", "strasse", "ort", "plz", "beschreibung", "telefon"],
    };
  },
  computed: {
    ...mapGetters({
      animations: "app/animations",
      validation: "app/validation",
      kunde: "auth/kou",
      api: "auth/apiSettings",
      toasts: "app/toasts",
      user: "auth/user",
      defaultAvatar: "auth/defaultAvatar",
      token: "auth/apiToken"
    }),
  },
  async created() {
    await this.init();    
  },
  methods: {
    async refreshDropzoneAuth() {           
      await this.$store.dispatch("auth/refreshToken");
      this.dropzone_options.headers.Authorization = "bearer " + this.token;
    }, 
    addEmail(){
      //console.log(!this.changedData.hasOwnProperty("additional_email"));
      if(!this.changedData.hasOwnProperty("additional_email")) this.changedData.additional_email = this.additional_email;
      this.additional_email.push(this.new_additional_email);
      this.new_additional_email = "";
      this.changedData.additional_email = [...this.additional_email];      
    },  
    removeEmail(idx) {
      this.additional_email.splice(idx, 1);
      this.changedData.additional_email = [...this.additional_email];
    },
    async init() {
      await this.setDropzoneOptions();
      this.setAvatar();
      this.setOldVals();
      this.setAdditionalEmail();
      this.ready = true;
    },
    setAdditionalEmail() {
      this.additional_email = this.kunde.additional_email == null ? [] : JSON.parse(this.kunde.additional_email);
    },  
    setOldVals() {
      this.oldVals = this.cloneNonReactive(this.kunde);
    },
    async setDropzoneOptions() {
      //kundenbild dropzone
      this.dropzone_options = {
        url: this.api.customUploads,
        thumbnailMethod: "contain",
        maxFiles: 1,
        init: function() {
          this.on("maxfilesexceeded", function(file) {
            this.removeAllFiles();
            this.addFile(file);
          });
        },
        dictDefaultMessage:
          '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload-cloud"><polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline></svg>',

        headers: {
          Authorization: "",
          "Cache-Control": null,
          "X-Requested-With": null,
        },
      };
    },
    async setAvatar() {
      const hasImage = this.kunde.image == null ? false : true;
      const image = hasImage ? this.kunde.image : this.defaultAvatar;
      if (hasImage) {
        try {
          this.showDZ = false;
          const response = await this.$store.dispatch("images/getImgURL", {
            id: image,
            mode: "imgtag",
            format: "thumb-400-full",
            volatile: true
          });

          this.avatarURL = response.url;
        } catch (error) {
          console.log(error);
          this.$toasted.show("Fehler beim Laden des Avatars.", this.toasts.failure);
        }
      }
    },
    hasError(field) {
      return this.validation_errors.indexOf(field) > -1 ? true : false;
    },
    async validate(field) {
      const fieldName = field.target.name;
      const changed = this.oldVals[fieldName] == this.kunde[fieldName] ? false : true;      
      const isError = this.validation_errors.indexOf(fieldName); 

      if(isError > -1) this.validation_errors.splice(isError, 1);
      if (!changed) {
        const isInChanged = this.changedData.hasOwnProperty(fieldName);        
        if(isInChanged) delete this.changedData[fieldName];
        return;
      }

      this.changedData[fieldName] = this.kunde[fieldName];
      const needsValidation = this.required.indexOf(fieldName) > -1 ? true : false;

      if (needsValidation) {        
        try {
          const validationPayload = {
            context: "kunden",
            field: fieldName,
            value: this.kunde[fieldName],
          };
          const validationResult = await this.$store.dispatch("app/validateField", validationPayload);
          if (!validationResult) this.validation_errors.push(fieldName);
          const isError = this.validation_errors.indexOf(fieldName);
          if (validationResult && isError > -1) this.validation_errors.splice(isError, 1);
        } catch (error) {
          console.log(error);
          this.$toasted.show(error, this.toasts.failure);
        }
      }      
    },
    async saveUser() {
      //const userFields = ["first_name", "last_name", "email"];
      this.updating.data = true;

      if(Object.keys(this.changedData).length == 0) {
        return;
      }

      //save changes for the user in object
      const mutateUser = {
        collection: "directus_users",
        item: this.user.id,
        changes: {
          first_name: this.kunde.first_name,
          last_name: this.kunde.last_name,
          email: this.kunde.email
        }
      }
      
      //apply changes
      try {
        await this.$store.dispatch("app/mutate", mutateUser);
      } catch( error ) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      } 

      //save changes for the kunde in an object 
      const mutateKunde = {
        collection: "kunde",
        item: this.kunde.id,
        changes: {
          ...this.cloneNonReactive(this.changedData)
        }   
      }

        //apply changes
        try {
          await this.$store.dispatch("app/mutate", mutateKunde)
        } catch( error ) {
          this.$toasted.show(error, this.toasts.failure);
        } finally {
          this.updating.data = false
        }

    },
    async saveField(field) {
      this.updating[field] = true;
      const userFields = ["first_name", "last_name", "email"];
      const needsUserUpdate = userFields.indexOf(field) > -1 ? true : false;
      try {
        let changesKu = {};
        changesKu[field] = this.kunde[field];

        const mutationKunde = {
          collection: "kunde",
          item: this.kunde.id,
          changes: changesKu,
        };

        await this.$store.dispatch("app/mutate", mutationKunde);

        if (needsUserUpdate) {
          let changesUser = {};
          changesUser[field] = this.kunde[field];

          const mutationUser = {
            collection: "directus_users",
            item: this.user.id,
            changes: changesUser,
          };
          await this.$store.dispatch("app/mutate", mutationUser);
        }
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      } finally {
        this.updating[field] = false;
      }
    },
    async processImageUpload(response, payload) {
      if (!response.xhr.status == 200) {
        this.$toasted.show("Fehler beim Upload", this.toast.failure);
        return;
      }

      const imgId = payload.data.id;

      try {
        const newImgPayload = {
          collection: "kunde",
          item: this.kunde.id,
          changes: {
            image: imgId,
          },
        };

        const newImgPayloadUser = {
          collection: "directus_users",
          item: this.user.id,
          changes: {
            avatar: imgId
          }
        }
        await this.$store.dispatch("app/mutate", newImgPayload);
        await this.$store.dispatch("app/mutate", newImgPayloadUser);
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      }
    },
    async validateNewPassword() {
      this.newPassword.error = {
        empty: false,
        notSame: false,
        tooSimple: false,
      };

      const empty = this.newPassword.once.length == 0 && this.newPassword.twice.length == 0;
      const same = this.newPassword.once == this.newPassword.twice;

      if (!same) {
        this.newPassword.error.notSame = true;
        return;
      }

      if (empty) {
        this.newPassword.error.empty = true;
        return;
      }

      try {
        this.updating.password = true;
        const newPasswordPayload = {
          collection: "directus_users",
          item: this.user.id,
          changes: {
            password: this.newPassword.once,
          },
        };
        console.log("new password payload");
        console.log(newPasswordPayload);
        await this.$store.dispatch("app/mutate", newPasswordPayload);       
        this.$toasted.show("Neues Passwort gespeichert.", this.toasts.success);
        this.rstNewPwFields();
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Speichern des Passworts.", this.toasts.failure);
      } finally {
        this.updating.password = false;
      }
    },
    rstNewPwFields() {
      this.newPassword = {
        once: "",
        twice: "",
        error: {
          notSame: false,
          empty: false,
          tooSimple: false,
        },
      }
    }
  },
};
</script>

<style scoped></style>

<style>

.additional-email-item {
  display:flex;
  justify-content:space-between;
  margin-bottom:2px;
}

#profile_kundenbild_dropzone div{
  width: auto !important;
}


</style>
